import { useMemo } from "react";
import styles from "./ConceptSummary.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { DualAxes } from "@ant-design/plots";
import { numberRegex } from "Explore/Utils/numberRegex";
import { LoadingSimpleComponent } from "Explore/Components";
import { SkeletonType } from "Explore/Config/ImageType";
import useDeviceCheck from "Hooks/useDeviceCheck";
import SectionTitle from "Explore/Components/SectionTitle";
import { InfoCircleOutlined } from "@ant-design/icons";

const ConceptSummary = ({ summary }) => {
  const { isMobile } = useDeviceCheck();
  const { statistics, statisticByYear } = useMemo(() => {
    const yearlyStats = summary.data?.yearly_stats || [];
    return {
      statistics: [
        {
          title: "authors",
          value: summary.data?.total_authors,
          icon: IconPack.faculty_outline_black,
        },
        {
          title: "citations",
          value: summary.data?.total_citations,
          icon: IconPack.citation,
        },
        {
          title: "institutions",
          value: summary.data?.total_institutions,
          icon: IconPack.institution_outline_black,
        },
        {
          title: "publications",
          value: summary.data?.total_publications,
          icon: IconPack.publications,
        },
      ].filter((e) => !!e.value),
      statisticByYear: {
        height: 300,
        title: "Statistic By Year",
        data: yearlyStats.map((e) => ({
          Year: e.year,
          Citations: e.citations,
          Publications: e.publications,
        })),
        xField: "Year",
        legend: true,
        children: [
          {
            type: "line",
            yField: "Citations",
            style: {
              stroke: "#5B8FF9",
              lineWidth: 2,
            },
            axis: {
              y: {
                title: "Citations",
                style: { titleFill: "#5B8FF9" },
              },
            },
          },
          {
            type: "line",
            yField: "Publications",
            style: {
              stroke: "#5AD8A6",
              lineWidth: 2,
            },
            axis: {
              y: {
                position: "right",
                title: "Publications",
                style: { titleFill: "#5AD8A6" },
              },
            },
          },
        ],
      },
    };
  }, [summary]);

  const render = () => {
    return (
      <div className={styles["concept-summary"]}>
        <div className={styles["statistics"]}>
          {statistics.map(({ title, value, icon }) => (
            <div className={styles["statistics__item"]} key={title}>
              <div className={styles["statistics__item--icon"]}>{icon}</div>
              <div className={styles["statistics__item--content"]}>
                <p className={styles["statistics__item--value"]}>
                  {numberRegex(value)}
                </p>
                <p className={styles["statistics__item--title"]}>{title}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles["graph"]}>
          <DualAxes {...statisticByYear} />
        </div>
      </div>
    );
  };

  return summary.isLoading ? (
    <LoadingSimpleComponent type={SkeletonType.PARAGRAPH} />
  ) : (
    <div>
      {isMobile ? (
        <SectionTitle
          title="Statistics"
          icon={<InfoCircleOutlined />}
          collapsible
          defaultOpen
        >
          {render()}
        </SectionTitle>
      ) : (
        render()
      )}
    </div>
  );
};

export default ConceptSummary;
